import { formatContactName, isLikelyWhatsAppLid } from "./formatPhoneNumber";
import erpClientDisplayName from "./erpClientDisplayName";
import { i18n } from "../translate/i18n";

/**
 * Label for a ticket row (list, notifications): ERP name when linked, else WhatsApp contact.
 */
export const getTicketDisplayName = (ticket) => {
  if (ticket?.erpDisplayName && String(ticket.erpDisplayName).trim()) {
    return String(ticket.erpDisplayName).trim();
  }
  if (ticket?.erpCliente) {
    const fromCliente = erpClientDisplayName(ticket.erpCliente);
    if (fromCliente) return fromCliente;
  }
  if (ticket?.contact?.erpDisplayName && String(ticket.contact.erpDisplayName).trim()) {
    return String(ticket.contact.erpDisplayName).trim();
  }
  const name = ticket?.contact?.name;
  const number = ticket?.contact?.number || "";
  const visibleName = name && !isLikelyWhatsAppLid(name) ? name : "";
  const visibleNumber = number && !isLikelyWhatsAppLid(number) ? number : "";
  return formatContactName(
    visibleName || visibleNumber || i18n.t("contacts.unknownNumber")
  );
};

export default getTicketDisplayName;
